module.exports = __webpack_public_path__ + "static/media/course8.d748bfc0.jpg";